import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import AuditLogsHome from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/audit-logs'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => ({ name: 'auditlogs_list', params: to.params }),
        },
        {
          path: 'list',
          name: 'auditlogs_list',
          meta: {
            reuseOnQueryChange: true,
            featureFlag: 'lilith_audit_logs',
            permissions: ['administrator'],
          },
          component: AuditLogsHome,
        },
      ],
    },
  ],
};
